import { useLocation } from "react-router-dom";
import { BRAND } from "@/site.config";

export default function Footer() {
  const year = new Date().getFullYear();
  const location = useLocation();
  const isLanding = location.pathname === "/";
  const contactHref = isLanding ? "#contact" : "/#contact";
  const anchor = (id) => (isLanding ? `#${id}` : `/#${id}`);
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/8"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-14 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-[#D4AF37] shadow-[0_0_16px_rgba(212,175,55,0.7)]" />
              <span className="font-display text-white text-2xl">
                Rubiemaze<span className="text-[#D4AF37]">.</span>
              </span>
            </div>
            <p className="mt-6 max-w-md text-white/60 text-sm md:text-base leading-relaxed">
              Hospitality consulting for nightclubs, bars and pre-launch
              venues across India. Strategy, on-ground audits and honest
              operator advice.
            </p>

            <a
              href={contactHref}
              data-testid="footer-cta"
              className="mt-10 inline-flex items-center gap-3 rounded-full bg-[#D4AF37] text-black px-6 py-3.5 text-sm font-medium hover:bg-[#f3d568] transition-colors"
            >
              Book My Consultation
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path
                  d="M5 12h14M13 5l7 7-7 7"
                  stroke="currentColor"
                  strokeWidth="1.8"
                />
              </svg>
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.28em] text-white/50">
              Contact
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  className="text-white/85 hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-email"
                >
                  {BRAND.email}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.whatsappUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="text-white/85 hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-whatsapp"
                >
                  WhatsApp {BRAND.whatsappDisplay}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.instagram}
                  target="_blank"
                  rel="noreferrer"
                  className="text-white/85 hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-instagram"
                >
                  Instagram {BRAND.instagramHandle}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.28em] text-white/50">
              Navigate
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ["About", "about"],
                ["Services", "services"],
                ["Process", "process"],
                ["Results", "results"],
                ["Reels", "reels"],
                ["FAQ", "faq"],
              ].map(([label, id]) => (
                <li key={id}>
                  <a
                    href={anchor(id)}
                    className="text-white/85 hover:text-[#D4AF37] transition-colors"
                    data-testid={`footer-link-${id}`}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 md:mt-16 pt-8 border-t border-white/8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/45">
          <div>
            © {year} Rubiemaze Inc. All rights reserved.
          </div>
          <div className="tracking-[0.28em] uppercase">
            Ritesh Sikri &middot; Est. Kolkata &middot; India
          </div>
        </div>

        {/* SEO paragraph — keyword-rich, human-readable, small print */}
        <p className="mt-8 text-white/35 text-[11px] leading-relaxed max-w-4xl">
          Rubiemaze Inc is the hospitality consulting practice founded by
          <strong className="text-white/55 font-normal"> Ritesh Sikri</strong>,
          India's leading nightlife consultant. With 20+ years behind the
          decks and inside nightclub, bar and lounge operations, Ritesh Sikri
          advises hospitality operators across Mumbai, Delhi, Bengaluru,
          Kolkata, Goa, Gurugram, Hyderabad and Chandigarh on profitability,
          menu engineering, guest experience, staff productivity and
          pre-launch strategy. Services include a 90-minute paid strategy
          call, a two-day on-ground nightclub audit and end-to-end pre-launch
          consulting.
        </p>
      </div>
    </footer>
  );
}
